import { json, type GeneratedFile } from './files';

/** The nyce.json entry that adds nyceBuddy3 to the NYCE.LOGIC client (buddy3 `docs/embedding.md` §2). */
export function buddyAddInEntry(baseUrl: string, system: string) {
  return { name: 'NyceBuddyAddIn', baseUrl, system };
}

export function buddyMcpText(buddyUrl: string, system: string): string {
  return `nyceBuddy MCP (Claude Desktop, Claude Code and other MCP clients)

Endpoint:  ${buddyUrl}/mcp
System:    ${system}   (header X-Nyce-System)

Each user creates a personal key in nyceBuddy (Settings → MCP keys, nbk_…) or signs in with OAuth when the
client supports it. The tenant needs the AUTH scope nycebuddy:mcp (and offline_access for long OAuth sessions).
`;
}

export function buddyFiles(buddyUrl: string, system: string): GeneratedFile[] {
  return [
    {
      name: 'nyce.json-entry.json',
      content: json(buddyAddInEntry(buddyUrl, system)),
      note: 'Add to the add-ins of the NYCE.LOGIC client’s nyce.json.',
    },
    { name: 'mcp.txt', content: buddyMcpText(buddyUrl, system), note: 'For the customer’s users.' },
  ];
}
